import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateFileDescriptionFailedAction = {
	type: 'DOCUMENT_TEMPLATE_FILE_DESCRIPTION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateFileDescriptionFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_FILE_DESCRIPTION_FAILED',
	payload,
});
